import { render, staticRenderFns } from "./TransactionValidation.vue?vue&type=template&id=25c0a659"
import script from "./TransactionValidation.vue?vue&type=script&lang=js"
export * from "./TransactionValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports